import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CircularProgress from '@material-ui/core/CircularProgress';

const Loading = (props) => {

    const spinnerClasses = classNames({
        spinner: true,
        sm: props.small === true
    });

    return (
        <div className="spinner-container">
            {do {
                if (props.error) {
                    <div>An error occurred while loading; please refresh.</div>;
                } else {
                    <CircularProgress
                        className={spinnerClasses}
                        size={props.small ? 100 : 200}
                        thickness={2}
                    />;
                }
            }}
        </div>
    );
};

Loading.propTypes = {
    error: PropTypes.object
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/common/Loading.js